import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { initials } from '../lib/userName';
import { Logo, type LogoId } from './Logo';

/**
 * Chip behind a logo, icon or initials (mockup `.lg`). The adjacent name labels
 * it, so the chip itself is decorative.
 */
export function LogoChip({
  children,
  logo,
  name,
  size = 'md',
}: {
  children?: ReactNode;
  logo?: LogoId | undefined;
  name?: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  return (
    <span
      aria-hidden="true"
      className={clsx('nv-lg', size === 'sm' && 'nv-sm', size === 'lg' && 'nv-big')}
    >
      {logo ? (
        <Logo id={logo} />
      ) : (
        (children ?? <span className="nv-ini">{initials(name ?? '')}</span>)
      )}
    </span>
  );
}
